module.exports = __webpack_public_path__ + "static/media/_DSC6159.bfba8c4c.jpg";